module.exports = __webpack_public_path__ + "static/media/desktop-masthead.2a781b0f.png";